"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var core_1 = require("@material-ui/core");
var ArrowRightOutlined_1 = __importDefault(require("@material-ui/icons/ArrowRightOutlined"));
function MenuItem(props) {
    return (React.createElement(react_router_dom_1.Link, { to: props.to, style: { textDecoration: 'none' }, "aria-label": props.primary },
        React.createElement(ListItem_1.default, { button: true },
            React.createElement(ListItemIcon_1.default, null, props.children || React.createElement(ArrowRightOutlined_1.default, null)),
            React.createElement(core_1.Typography, { variant: "inherit", noWrap: true, style: { fontFamily: 'Lato' } }, props.primary))));
}
exports.default = (MenuItem);
//# sourceMappingURL=MenuItem.js.map